<template>
    <basic-card>
        <template slot="header">
            Payment details
        </template>
        <template v-if="payment.realizationDetails != undefined && payment.realizationDetails.bankMessage != undefined">
            <div style="margin: 10px; background-color: var(--accent-color-minus-75); padding: 5px 10px 10px 10px; border-radius: 10px;">
                <h1>Response from bank</h1>
                {{payment.realizationDetails.bankMessage}}
            </div>
        </template>
        <form-wrapper>
            <form-select-input caption="Payment type" v-model="payment.paymentType" :options="paymentTypeOptions"/>
            <form-number-input required caption="Amount" v-model="payment.amount"/>
            <form-select-input required caption="Currency" v-model="payment.currencyId" :options="currenciesOptions" :custom-renderer="customRenderers.CurrencyVisualizer"/>
            <!-- internal party -->
            <form-select-input required caption="Account" :custom-renderer="customRenderers.AccountVisualizer" v-model="payment.sourceAccountRef.accountId" :options="internalAccountOptions"/>
            <form-select-input caption="Counterparty" v-model="payment.counterPartyId" :options="partiesOptions"/>
            <form-select-input required caption="Counter account" v-model="payment.targetAccountRef.accountId" :options="accountOptions"/>
            <form-date-input caption="Due date" required v-model="payment.dueDate"/>
            <form-text-input caption="Memo" v-model="payment.memo"/>
            <form-select-input caption="Priority" v-model="payment.priority" :options="priorityOptions"/>
        </form-wrapper>
        <collapsible-content v-if="payment.paymentType == 'DOMESTIC'">
            <template slot="header">CZ payment details</template>
            <form-wrapper>
                <form-text-input caption="Variable symbol" v-model="payment.czePaymentDetails.variableSymbol"/>
                <form-select-input caption="Constant symbol" v-model="payment.czePaymentDetails.constantSymbol" :options="constantSymbolsOptions"/>
                <form-text-input caption="Specific symbol" v-model="payment.czePaymentDetails.specificSymbol"/>
                <form-text-input disabled caption="Payment reason" value="380 - Other services"/>
            </form-wrapper>
        </collapsible-content>

        <collapsible-content v-if="payment.paymentType == 'T2'">
            <template slot="header">T2 payment details</template>
            <form-wrapper>
                <form-text-input caption="Variable symbol" v-model="payment.czePaymentDetails.variableSymbol"/>
                <form-select-input caption="Constant symbol" v-model="payment.czePaymentDetails.constantSymbol" :options="constantSymbolsOptions"/>
                <form-text-input caption="Specific symbol" v-model="payment.czePaymentDetails.specificSymbol"/>
                <form-text-input disabled caption="Payment reason" value="380 - Other services"/>
                <form-text-input caption="Mandatory message" v-model="payment.foreignPaymentDetails.mandatoryMessage"/>
                <form-text-input required caption="Beneficiary name" v-model="payment.foreignPaymentDetails.beneficiaryDetails.name"/>
                <form-select-input caption="Beneficiary country" :options="countryOptions" v-model="payment.foreignPaymentDetails.beneficiaryDetails.country"/>
                <form-text-input caption="Beneficiary city" v-model="payment.foreignPaymentDetails.beneficiaryDetails.city"/>
                <form-text-input caption="Beneficiary street" v-model="payment.foreignPaymentDetails.beneficiaryDetails.street"/>
            </form-wrapper>
        </collapsible-content>
        <collapsible-content v-if="payment.paymentType == 'FOREIGN'">
            <template slot="header">Foreign payment details</template>
            <form-wrapper>
                <form-text-input required caption="Beneficiary name" v-model="payment.foreignPaymentDetails.beneficiaryDetails.name"/>
                <form-select-input required caption="Beneficiary country" :options="countryOptions" v-model="payment.foreignPaymentDetails.beneficiaryDetails.country"/>
                <form-text-input required caption="Beneficiary city" v-model="payment.foreignPaymentDetails.beneficiaryDetails.city"/>
                <form-text-input required caption="Beneficiary street" v-model="payment.foreignPaymentDetails.beneficiaryDetails.street"/>
                <form-text-input disabled caption="Payment reason" value="380 - Other services"/>
                <form-select-input required caption="Fee disposition" v-model="payment.foreignPaymentDetails.feeDisposition" :options="feeDispositionOptions"/>
            </form-wrapper>
        </collapsible-content>


        <simple-button v-if="enableSave" @press="emitSave">Save payment</simple-button>
    </basic-card>
</template>

<script>
    import BasicCard from "../components/layout/BasicCard";
    import FormWrapper from "../components/form/FormWrapper";
    import SimpleButton from "../components/button/SimpleButton";
    import FormTextInput from "../components/form/FormTextInput";
    import FormNumberInput from "../components/form/FormNumberInput";
    import FormSelectInput from "../components/form/FormSelectInput";
    import FormDateInput from "../components/form/FormDateInput";
    import {mapGetters} from "vuex";
    import FormCheckboxInput from "../components/form/FormCheckboxInput";
    import CollapsibleContent from "../components/CollapsibleContent";
    import SimpleLayout from "../components/layout/SimpleLayout";
    export default {
        name: "PaymentFormCard",
        props: {
            payment: Object,
            enableSave: Boolean
        },
        computed: {
            ... mapGetters({
                "currenciesOptions": "currencies/currenciesOptions",
                "accounts": "banking/accounts",
                "accountsByInternal": "banking/accountsByInternal",
                "accountOwnerships": "accountOwnerships/accountOwnerships",
                "parties": "parties/parties"
            }),
            paymentReason() {
                return [{id: "1148", name: "DPH"}, {id: "380", name: "Ostatní služby"}];
            },
            countryOptions() {
              return ["AX","AL","DZ","VI","AS","AD","AO","AI","AQ","AG","AR","AM","AW","AU","AZ","BS","BH","BD","BB","BE","BZ","BY","BJ","BM","BT","BO","BQ","BA","BW","BV","BR","IO","VG","BN","BG","BF","BI","TD","CK","CI","CW","ME","CZ","CN","DK","TL","GP","GF","MQ","RE","DM","DO","DJ","EG","EC","ER","EE","ET","FO","FK","FJ","PH","FI","FR","TF","PF","GA","GM","GH","GI","GD","GL","GE","GU","GT","GG","GW","GN","GY","HT","HM","HN","HK","CL","HR","IN","ID","IQ","IR","IE","IS","IT","IL","JM","JP","YE","JE","ZA","JO","GS","KY","KH","CM","CA","CV","QA","KZ","KE","KI","CC","CO","KM","CD","CG","KR","KP","CR","TO","CU","KW","CY","KG","LA","LS","LB","LR","LY","LI","LT","LV","LU","MO","MG","HU","MK","MY","MW","MV","ML","MT","MA","MH","MU","MR","UM","MX","FM","MD","MC","MN","MS","MZ","MM","NA","NR","DE","NP","WS","NE","NG","NI","NU","NL","AN","NF","NO","NC","NZ","PS","OM","IM","PK","PW","PA","PG","PY","PE","PN","PL","PR","PT","AT","XK","RS","GQ","RO","RU","RW","GR","BL","PM","SV","SM","SA","SN","SC","SL","SG","SK","SI","SO","AE","MP","LK","CF","SD","SR","SJ","SH","LC","KN","MF","SX","ST","VC","SZ","SY","SB","ES","SE","CH","TJ","TZ","TH","TW","TCH","TK","TG","TT","TN","TR","TM","TC","TV","UG","UA","UY","US","UZ","YT","CX","VU","VA","GB","VE","VN","TP","WF","ZR","ZM","EH","ZW"]
                  .map(country => ({id: country, name: country}))
            },
            priorityOptions() {
              return [{name: 'Standard', id: 'STANDARD'}, {name: 'Express', id: 'EXPRESS'}];
            },
            paymentTypeOptions() {
                return [{name: 'Domestic Payment', id: 'DOMESTIC'}, {name: 'T2 Payment', id: 'T2'}, {name: 'Foreign payment', id: 'FOREIGN'}]
            },
            feeDispositionOptions() {
                return [{name: 'Shared', id: 'SHA'}, {name: 'Beneficiary', id: 'BEN'}, {name: 'Ours', id: 'OUR'}];
            },
            constantSymbolsOptions() {
              return [{id: 4, name: '4 platby za zboží (kromě plateb pod symbolem 10X, 80X)'},
                  {id: 6, name: '6 platby za zboží (kromě plateb pod symbolem 10X, 80X)'},
                  {id: 8, name: '8 platby za zboží (kromě plateb pod symbolem 10X, 80X)'},
                  {id: 9, name: '9 platby za zboží (kromě plateb pod symbolem 10X, 80X)'},
                  {id: 24, name: '24 platby za dodávky investiční povahy'},
                  {id: 26, name: '26 platby za dodávky investiční povahy'},
                  {id: 28, name: '28 platby za dodávky investiční povahy'},
                  {id: 29, name: '29 platby za dodávky investiční povahy'},
                  {id: 34, name: '34 prostředky na mzdy'},
                  {id: 36, name: '36 prostředky na mzdy'},
                  {id: 38, name: '38 prostředky na mzdy'},
                  {id: 39, name: '39 prostředky na mzdy'},
                  {id: 54, name: '54 penále, poplatky z prodlení a jiné majetkové sankce'},
                  {id: 56, name: '56 penále, poplatky z prodlení a jiné majetkové sankce'},
                  {id: 58, name: '58 penále, poplatky z prodlení a jiné majetkové sankce'},
                  {id: 59, name: '59 penále, poplatky z prodlení a jiné majetkové sankce'},
                  {id: 64, name: '64 převody prostředků na mzdy a ostatní osobní náklady'},
                  {id: 66, name: '66 převody prostř.na mzdy a ostatní osobní náklady'},
                  {id: 68, name: '68 převody prostř.na mzdy a ostatní osobní náklady'},
                  {id: 79, name: '79 tržby za prodané zboží a poskytnuté stravování'},
                  {id: 102, name: '102 platby za zemědělské výrobky'},
                  {id: 104, name: '104 platby za zemědělské výrobky'},
                  {id: 106, name: '106 platby za zemědělské výrobky'},
                  {id: 108, name: '108 platby za zemědělské výrobky'},
                  {id: 109, name: '109 platby za zemědělské výrobky'},
                  {id: 114, name: '114 odvody příspěvkových organizací'},
                  {id: 116, name: '116 odvody příspěvkových organizací'},
                  {id: 117, name: '117 odvody příspěvkových organizací'},
                  {id: 118, name: '118 odvody příspěvkových organizací'},
                  {id: 119, name: '119 odvody příspěvkových organizací'},
                  {id: 134, name: '134 srážky z mezd'},
                  {id: 136, name: '136 srážky z mezd'},
                  {id: 137, name: '137 srážky z mezd'},
                  {id: 138, name: '138 srážky z mezd'},
                  {id: 139, name: '139 srážky z mezd'},
                  {id: 149, name: '149 srážka daně z úroků'},
                  {id: 154, name: '154 hospodářsko-operativní výdaje'},
                  {id: 156, name: '156 hospodářsko-operativní výdaje'},
                  {id: 158, name: '158 hospodářsko-operativní výdaje'},
                  {id: 159, name: '159 hospodářsko-operativní výdaje'},
                  {id: 164, name: '164 splátky úvěrů a půjček'},
                  {id: 168, name: '168 splátky úvěrů a půjček'},
                  {id: 169, name: '169 splátky úvěrů a půjček'},
                  {id: 179, name: '179 tržby za poskytnuté služby'},
                  {id: 254, name: '254 platby v Kč určené k úhradám do zahraničí'},
                  {id: 258, name: '258 platby v Kč určené k úhradám do zahraničí'},
                  {id: 279, name: '279 vklady na účty zemědělských družstev'},
                  {id: 302, name: '302 platby za služby (kromě plateb pod symbolem 40X)'},
                  {id: 304, name: '304 platby za služby (kromě plateb pod symbolem 40X)'},
                  {id: 306, name: '306 platby za služby (kromě plateb pod symbolem 40X)'},
                  {id: 308, name: '308 platby za služby (kromě plateb pod symbolem 40X)'},
                  {id: 309, name: '309 platby za služby (kromě plateb pod symbolem 40X)'},
                  {id: 354, name: '354 hotovostní platba na poště'},
                  {id: 358, name: '358 hotovostní platba na poště'},
                  {id: 379, name: '379 ostatní příjmy'},
                  {id: 402, name: '402 platby za přepravné'},
                  {id: 404, name: '404 platby za přepravné'},
                  {id: 406, name: '406 platby za přepravné'},
                  {id: 408, name: '408 platby za přepravné'},
                  {id: 409, name: '409 platby za přepravné'},
                  {id: 414, name: '414 odvody vedlejších hospodářství'},
                  {id: 416, name: '416 odvody vedlejších hospodářství'},
                  {id: 417, name: '417 odvody vedlejších hospodářství'},
                  {id: 418, name: '418 odvody vedlejších hospodářství'},
                  {id: 419, name: '419 odvody vedlejších hospodářství'},
                  {id: 459, name: '459 hotovostní výplaty z účtů zemědělských družstev'},
                  {id: 479, name: '479 vrácené mzdy'},
                  {id: 554, name: '554 finanční platby ostatní'},
                  {id: 556, name: '556 finanční platby ostatní'},
                  {id: 558, name: '558 finanční platby ostatní'},
                  {id: 559, name: '559 finanční platby ostatní'},
                  {id: 579, name: '579 vrácené hotovosti na nákup'},
                  {id: 854, name: '854 přechodně poskytnuté půjčky'},
                  {id: 856, name: '856 přechodně poskytnuté půjčky'},
                  {id: 858, name: '858 přechodně poskytnuté půjčky'},
                  {id: 859, name: '859 přechodně poskytnuté půjčky'},
                  {id: 934, name: '934 dávky sociálního zabezpečení'},
                  {id: 936, name: '936 dávky sociálního zabezpečení'},
                  {id: 938, name: '938 dávky sociálního zabezpečení'},
                  {id: 939, name: '939 dávky sociálního zabezpečení'},
                  {id: 959, name: '959 dotace poštám'},
                  {id: 964, name: '964 ostatní převody'},
                  {id: 966, name: '966 ostatní převody'},
                  {id: 968, name: '968 ostatní převody'},
                  {id: 1144, name: '1144 běžná platba daní, poplatků, odvodů a cel, vč. záloh a splátek'},
                  {id: 1146, name: '1146 běžná platba daní, poplatků, odvodů a cel, vč. záloh a splátek'},
                  {id: 1147, name: '1147 běžná platba daní, poplatků, odvodů a cel, vč. záloh a splátek'},
                  {id: 1148, name: '1148 běžná platba daní, poplatků, odvodů a cel, vč. záloh a splátek'},
                  {id: 1149, name: '1149 běžná platba daní, poplatků, odvodů a cel, vč. záloh a splátek'},
                  {id: 1314, name: '1314 místní poplatky'},
                  {id: 1316, name: '1316 místní poplatky'},
                  {id: 1317, name: '1317 místní poplatky'},
                  {id: 1318, name: '1318 místní poplatky'},
                  {id: 1319, name: '1319 místní poplatky'},
                  {id: 1379, name: '1379 vklady obyvatel'},
                  {id: 1514, name: '1514 převody prostředků účelově určených'},
                  {id: 1516, name: '1516 převody prostředků účelově určených'},
                  {id: 1517, name: '1517 převody prostředků účelově určených'},
                  {id: 1518, name: '1518 převody prostředků účelově určených'},
                  {id: 1519, name: '1519 převody prostředků účelově určených'},
                  {id: 1559, name: '1559 výplaty z vkladů obyvatelstva'},
                  {id: 1754, name: '1754 zvláštní příspěvky zúčtované na investiční účty'},
                  {id: 1756, name: '1756 zvláštní příspěvky zúčtované na investiční účty'},
                  {id: 1758, name: '1758 zvláštní příspěvky zúčtované na investiční účty'},
                  {id: 1759, name: '1759 zvláštní příspěvky zúčtované na investiční účty'},
                  {id: 1814, name: '1814 převody prostředků na ostatní (neinvestiční) účely'},
                  {id: 1816, name: '1816 převody prostředků na ostatní (neinvestiční) účely'},
                  {id: 1817, name: '1817 převody prostředků na ostatní (neinvestiční) účely'},
                  {id: 1818, name: '1818 převody prostředků na ostatní (neinvestiční) účely'},
                  {id: 1819, name: '1819 převody prostředků na ostatní (neinvestiční) účely'},
                  {id: 1959, name: '1959 dotace bankám'},
                  {id: 1979, name: '1979 odvody pošt'},
                  {id: 2054, name: '2054 nákup cenných papírů'},
                  {id: 2056, name: '2056 nákup cenných papírů'},
                  {id: 2058, name: '2058 nákup cenných papírů'},
                  {id: 2059, name: '2059 nákup cenných papírů'},
                  {id: 2099, name: '2099 nákup cenných papírů'},
                  {id: 2144, name: '2144 platby doměrků'},
                  {id: 2146, name: '2146 platby doměrků'},
                  {id: 2147, name: '2147 platby doměrků'},
                  {id: 2148, name: '2148 platby doměrků'},
                  {id: 2149, name: '2149 platby doměrků'},
                  {id: 2514, name: '2514 příjmy z činnosti lékárenské služby'},
                  {id: 2516, name: '2516 příjmy z činnosti lékárenské služby'},
                  {id: 2517, name: '2517 příjmy z činnosti lékárenské služby'},
                  {id: 2518, name: '2518 příjmy z činnosti lékárenské služby'},
                  {id: 2519, name: '2519 příjmy z činnosti lékárenské služby'},
                  {id: 2554, name: '2554 úhrady pojistných plnění pojišťovnami'},
                  {id: 2556, name: '2556 úhrady pojistných plnění pojišťovnami'},
                  {id: 2558, name: '2558 úhrady pojistných plnění pojišťovnami'},
                  {id: 2559, name: '2559 úhrady pojistných plnění pojišťovnami'},
                  {id: 2614, name: '2614 příjmy od obyvatelstva'},
                  {id: 2616, name: '2616 příjmy od obyvatelstva'},
                  {id: 2617, name: '2617 příjmy od obyvatelstva'},
                  {id: 2618, name: '2618 příjmy od obyvatelstva'},
                  {id: 2619, name: '2619 příjmy od obyvatelstva'},
                  {id: 2699, name: '2699 devizové operace nákup'},
                  {id: 2714, name: '2714 příjmy od organizací'},
                  {id: 2716, name: '2716 příjmy od organizací'},
                  {id: 2717, name: '2717 příjmy od organizací'},
                  {id: 2718, name: '2718 příjmy od organizací'},
                  {id: 2719, name: '2719 příjmy od organizací'},
                  {id: 2979, name: '2979 odvody bank'},
                  {id: 3014, name: '3014 příjmy z vedlejší hospodářské činnosti škol'},
                  {id: 3016, name: '3016 příjmy z vedlejší hospodářské činnosti škol'},
                  {id: 3017, name: '3017 příjmy z vedlejší hospodářské činnosti škol'},
                  {id: 3018, name: '3018 příjmy z vedlejší hospodářské činnosti škol'},
                  {id: 3019, name: '3019 příjmy z vedlejší hospodářské činnosti škol'},
                  {id: 3054, name: '3054 prodej cenných papírů'},
                  {id: 3056, name: '3056 prodej cenných papírů'},
                  {id: 3058, name: '3058 prodej cenných papírů'},
                  {id: 3059, name: '3059 prodej cenných papírů'},
                  {id: 3099, name: '3099 prodej cenných papírů'},
                  {id: 3144, name: '3144 platby příslušenství'},
                  {id: 3146, name: '3146 platby příslušenství'},
                  {id: 3147, name: '3147 platby příslušenství'},
                  {id: 3148, name: '3148 platby příslušenství'},
                  {id: 3149, name: '3149 platby příslušenství'},
                  {id: 3214, name: '3214 příjmy z prodeje bytů do osobního vlastnictví'},
                  {id: 3216, name: '3216 příjmy z prodeje bytů do osobního vlastnictví'},
                  {id: 3217, name: '3217 příjmy z prodeje bytů do osobního vlastnictví'},
                  {id: 3218, name: '3218 příjmy z prodeje bytů do osobního vlastnictví'},
                  {id: 3219, name: '3219 příjmy z prodeje bytů do osobního vlastnictví'},
                  {id: 3514, name: '3514 lázeňský poplatek'},
                  {id: 3516, name: '3516 lázeňský poplatek'},
                  {id: 3517, name: '3517 lázeňský poplatek'},
                  {id: 3518, name: '3518 lázeňský poplatek'},
                  {id: 3519, name: '3519 lázeňský poplatek'},
                  {id: 3552, name: '3552 platby penzijním fondům od zaměstnavatele'},
                  {id: 3554, name: '3554 platby pojistného pojišťovnám'},
                  {id: 3556, name: '3556 platby pojistného pojišťovnám'},
                  {id: 3558, name: '3558 platby pojistného pojišťovnám'},
                  {id: 3559, name: '3559 platby pojistného pojišťovnám'},
                  {id: 3614, name: '3614 pokuty ukládané a vybírané obcí a okresními úřady'},
                  {id: 3616, name: '3616 pokuty ukládané a vybírané obcí a okresními úřady'},
                  {id: 3617, name: '3617 pokuty ukládané a vybírané obcí a okresními úřady'},
                  {id: 3618, name: '3618 pokuty ukládané a vybírané obcí a okresními úřady'},
                  {id: 3619, name: '3619 pokuty ukládané a vybírané obcí a okresními úřady'},
                  {id: 3699, name: '3699 devizové operace prodej'},
                  {id: 3714, name: '3714 sankční poplatky'},
                  {id: 3716, name: '3716 sankční poplatky'},
                  {id: 3717, name: '3717 sankční poplatky'},
                  {id: 3719, name: '3719 sankční poplatky'},
                  {id: 4054, name: '4054 proplacení výnosů z cenných papírů'},
                  {id: 4056, name: '4056 proplacení výnosů z cenných papírů'},
                  {id: 4058, name: '4058 proplacení výnosů z cenných papírů'},
                  {id: 4059, name: '4059 proplacení výnosů z cenných papírů'},
                  {id: 4099, name: '4099 proplacení výnosů z cenných papírů'},
                  {id: 4144, name: '4144 vratky ve prospěch účtů daňových subjektů'},
                  {id: 4146, name: '4146 vratky ve prospěch účtů daňových subjektů'},
                  {id: 4147, name: '4147 vratky ve prospěch účtů daňových subjektů'},
                  {id: 4148, name: '4148 vratky ve prospěch účtů daňových subjektů'},
                  {id: 4149, name: '4149 vratky ve prospěch účtů daňových subjektů'},
                  {id: 4214, name: '4214 příjmy plynoucí z prodeje nemovitého majetku'},
                  {id: 4216, name: '4216 příjmy plynoucí z prodeje nemovitého majetku'},
                  {id: 4217, name: '4217 příjmy plynoucí z prodeje nemovitého majetku'},
                  {id: 4218, name: '4218 příjmy plynoucí z prodeje nemovitého majetku'},
                  {id: 4219, name: '4219 příjmy plynoucí z prodeje nemovitého majetku'},
                  {id: 4314, name: '4314 ostatní a nahodilé příjmy'},
                  {id: 4316, name: '4316 ostatní a nahodilé příjmy'},
                  {id: 4317, name: '4317 ostatní a nahodilé příjmy'},
                  {id: 4318, name: '4318 ostatní a nahodilé příjmy'},
                  {id: 4319, name: '4319 ostatní a nahodilé příjmy'},
                  {id: 4514, name: '4514 příspěvky vedlejším hospodářstvím'},
                  {id: 4516, name: '4516 příspěvky vedlejším hospodářstvím'},
                  {id: 4517, name: '4517 příspěvky vedlejším hospodářstvím'},
                  {id: 4518, name: '4518 příspěvky vedlejším hospodářstvím'},
                  {id: 4519, name: '4519 příspěvky vedlejším hospodářstvím'},
                  {id: 4614, name: '4614 příspěvky příspěvkovým organizacím na provoz'},
                  {id: 4616, name: '4616 příspěvky příspěvkovým organizacím na provoz'},
                  {id: 4617, name: '4617 příspěvky příspěvkovým organizacím na provoz'},
                  {id: 4618, name: '4618 příspěvky příspěvkovým organizacím na provoz'},
                  {id: 4619, name: '4619 příspěvky příspěvkovým organizacím na provoz'},
                  {id: 4714, name: '4714 příspěvky občanským sdružením'},
                  {id: 4716, name: '4716 příspěvky občanským sdružením'},
                  {id: 4717, name: '4717 příspěvky občanským sdružením'},
                  {id: 4718, name: '4718 příspěvky občanským sdružením'},
                  {id: 4719, name: '4719 příspěvky občanským sdružením'},
                  {id: 4814, name: '4814 dotace církvím a náboženským společnostem'},
                  {id: 4816, name: '4816 dotace církvím a náboženským společnostem'},
                  {id: 4817, name: '4817 dotace církvím a náboženským společnostem'},
                  {id: 4818, name: '4818 dotace církvím a náboženským společnostem'},
                  {id: 4819, name: '4819 dotace církvím a náboženským společnostem'},
                  {id: 4914, name: '4914 příspěvky a dary mezinárodním organizacím'},
                  {id: 4916, name: '4916 příspěvky a dary mezinárodním organizacím'},
                  {id: 4917, name: '4917 příspěvky a dary mezinárodním organizacím'},
                  {id: 4918, name: '4918 příspěvky a dary mezinárodním organizacím'},
                  {id: 4919, name: '4919 příspěvky a dary mezinárodním organizacím'},
                  {id: 5014, name: '5014 dotace příspěvkovým a ostatním organizacím na investice'},
                  {id: 5016, name: '5016 dotace příspěvkovým a ostatním organizacím na investice'},
                  {id: 5017, name: '5017 dotace příspěvkovým a ostatním organizacím na investice'},
                  {id: 5018, name: '5018 dotace příspěvkovým a ostatním organizacím na investice'},
                  {id: 5019, name: '5019 dotace příspěvkovým a ostatním organizacím na investice'},
                  {id: 5144, name: '5144 převody prostředků mezi účty správců daní'},
                  {id: 5146, name: '5146 převody prostředků mezi účty správců daní'},
                  {id: 5147, name: '5147 převody prostředků mezi účty správců daní'},
                  {id: 5148, name: '5148 převody prostředků mezi účty správců daní'},
                  {id: 5149, name: '5149 převody prostředků mezi účty správců daní'},
                  {id: 5314, name: '5314 ostatní příspěvky'},
                  {id: 5316, name: '5316 ostatní příspěvky'},
                  {id: 5317, name: '5317 ostatní příspěvky'},
                  {id: 5318, name: '5318 ostatní příspěvky'},
                  {id: 5319, name: '5319 ostatní příspěvky'},
                  {id: 5514, name: '5514 dotace provozní'},
                  {id: 5516, name: '5516 dotace provozní'},
                  {id: 5517, name: '5517 dotace provozní'},
                  {id: 5518, name: '5518 dotace provozní'},
                  {id: 5519, name: '5519 dotace provozní'},
                  {id: 5614, name: '5614 dotace na investice'},
                  {id: 5616, name: '5616 dotace na investice'},
                  {id: 5617, name: '5617 dotace na investice'},
                  {id: 5618, name: '5618 dotace na investice'},
                  {id: 5619, name: '5619 dotace na investice'},
                  {id: 6144, name: '6144 silniční daň placená celnímu orgánu'},
                  {id: 6146, name: '6146 silniční daň placená celnímu orgánu'},
                  {id: 6147, name: '6147 silniční daň placená celnímu orgánu'},
                  {id: 6148, name: '6148 silniční daň placená celnímu orgánu'},
                  {id: 6149, name: '6149 silniční daň placená celnímu orgánu'},
                  {id: 6414, name: '6414 ostatní účelové dotace ze státního rozpočtu'},
                  {id: 6416, name: '6416 ostatní účelové dotace ze státního rozpočtu'},
                  {id: 6417, name: '6417 ostatní účelové dotace ze státního rozpočtu'},
                  {id: 6418, name: '6418 ostatní účelové dotace ze státního rozpočtu'},
                  {id: 6419, name: '6419 ostatní účelové dotace ze státního rozpočtu'},
                  {id: 7114, name: '7114 dotace na investiční výstavbu ze státních fondů'},
                  {id: 7116, name: '7116 dotace na investiční výstavbu ze státních fondů'},
                  {id: 7117, name: '7117 dotace na investiční výstavbu ze státních fondů'},
                  {id: 7118, name: '7118 dotace na investiční výstavbu ze státních fondů'},
                  {id: 7119, name: '7119 dotace na investiční výstavbu ze státních fondů'},
                  {id: 7144, name: '7144 poplatky placené celnímu orgánu'},
                  {id: 7146, name: '7146 poplatky placené celnímu orgánu'},
                  {id: 7147, name: '7147 poplatky placené celnímu orgánu'},
                  {id: 7148, name: '7148 poplatky placené celnímu orgánu'},
                  {id: 7149, name: '7149 poplatky placené celnímu orgánu'},
                  {id: 7214, name: '7214 dotace okresním úřadům a obcím'},
                  {id: 7216, name: '7216 dotace okresním úřadům a obcím'},
                  {id: 7217, name: '7217 dotace okresním úřadům a obcím'},
                  {id: 7218, name: '7218 dotace okresním úřadům a obcím'},
                  {id: 7219, name: '7219 dotace okresním úřadům a obcím'},
                  {id: 7514, name: '7514 vztahy státního rozpočtu k bance'},
                  {id: 7516, name: '7516 vztahy státního rozpočtu k bance'},
                  {id: 7517, name: '7517 vztahy státního rozpočtu k bance'},
                  {id: 7518, name: '7518 vztahy státního rozpočtu k bance'},
                  {id: 7519, name: '7519 vztahy státního rozpočtu k bance'},
                  {id: 7614, name: '7614 dávky sociálního zabezpečení'},
                  {id: 7616, name: '7616 dávky sociálního zabezpečení'},
                  {id: 7617, name: '7617 dávky sociálního zabezpečení'},
                  {id: 7618, name: '7618 dávky sociálního zabezpečení'},
                  {id: 7619, name: '7619 dávky sociálního zabezpečení'},
                  {id: 7714, name: '7714 státní sociální podpora'},
                  {id: 7716, name: '7716 státní sociální podpora'},
                  {id: 7717, name: '7717 státní sociální podpora'},
                  {id: 7718, name: '7718 státní sociální podpora'},
                  {id: 7719, name: '7719 státní sociální podpora'},
                  {id: 8144, name: '8144 ostatní platby daní, poplatků a odvodů'},
                  {id: 8146, name: '8146 ostatní platby daní, poplatků a odvodů'},
                  {id: 8147, name: '8147 ostatní platby daní, poplatků a odvodů'},
                  {id: 8148, name: '8148 ostatní platby daní, poplatků a odvodů'},
                  {id: 8149, name: '8149 ostatní platby daní, poplatků a odvodů'},
                  {id: 9114, name: '9114 finanční zúčtování'},
                  {id: 9116, name: '9116 finanční zúčtování'},
                  {id: 9117, name: '9117 finanční zúčtování'},
                  {id: 9118, name: '9118 finanční zúčtování'},
                  {id: 9119, name: '9119 finanční zúčtování'},
                  {id: 9144, name: '9144 zrušené dávky placené celnímu orgánu'},
                  {id: 9146, name: '9146 zrušené dávky placené celnímu orgánu'},
                  {id: 9147, name: '9147 zrušené dávky placené celnímu orgánu'},
                  {id: 9148, name: '9148 zrušené dávky placené celnímu orgánu'},
                  {id: 9149, name: '9149 zrušené dávky placené celnímu orgánu'},
                  {id: 9617, name: '9617 vratky příspěvků na členské podíly v družstevní stabilizační bytové výstavbě'},
                  {id: 9814, name: '9814 mimořádné odvody v průběhu roku'},
                  {id: 9816, name: '9816 mimořádné odvody v průběhu roku'},
                  {id: 9817, name: '9817 mimořádné odvody v průběhu roku'},
                  {id: 9818, name: '9818 mimořádné odvody v průběhu roku'},
                  {id: 9819, name: '9819 mimořádné odvody v průběhu roku'},
                  {id: 9914, name: '9914 účelové prostředky ze státního rozpočtu poskytnuté z vládní rozpočtové rezervy'},
                  {id: 9916, name: '9916 účelové prostředky ze státního rozpočtu poskytnuté z vládní rozpočtové rezervy'},
                  {id: 9917, name: '9917 účelové prostředky ze státního rozpočtu poskytnuté z vládní rozpočtové rezervy'},
                  {id: 9918, name: '9918 účelové prostředky ze státního rozpočtu poskytnuté z vládní rozpočtové rezervy'},
                  {id: 9919, name: '9919 účelové prostředky ze státního rozpočtu poskytnuté z vládní rozpočtové rezervy'}]
                  .map(entry => ({ id: `${entry.id}`, name: entry.name}));
            },
            accountOptions() {
                let accounts = this.accounts.map(acc => ({id: acc.id, name: `${acc.name} (${acc.currency})`}));
                if(this.payment.counterPartyId != null) {
                    let ownerships = this.accountOwnerships.filter(ownership => ownership.partyReference.partyId == this.payment.counterPartyId);
                    accounts = accounts.filter(acc => ownerships.find(ownership => acc.id == ownership.accountId) != undefined);
                }
                return accounts;
            },
            internalAccountOptions() {
                return this.accountsByInternal(true).map(acc => ({id: acc.id, name: `${acc.name} (${acc.currency})`}));
            },
            partiesOptions() {
                return this.parties.map(party => ({ id: party.id, name: party.displayName}))
            },
            internalPartiesOptions() {
                return this.parties.filter(
                    party => {
                        return party.partyRoles.some(partyRole => this.supportedPartyRoleIds.includes(partyRole.partyRoleTypeId))
                    }
                ).map(party => ({
                    name: party.displayName,
                    id: party.partyRoles.filter(partyRole => this.supportedPartyRoleIds.includes(partyRole.partyRoleTypeId))[0].id
                }))
            }
        },
        methods: {
            emitSave() {
                this.$emit('save', this.payment);
            }
        },
        components: {
            SimpleLayout,
            CollapsibleContent,
            FormCheckboxInput,
            FormDateInput,
            FormSelectInput, FormNumberInput, FormTextInput, SimpleButton, FormWrapper, BasicCard},
        data: function () {
            return { }
        }
    }
</script>

<style lang="scss" scoped>

</style>